import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "config.js";
import OrcaXBgLogo from '../../../assets/img/OrcaXBgLogo.jpg';
import {
  Button,
  Card,
  Form,
  Container,
  Col,
  Alert
} from "react-bootstrap";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [cardClasses, setCardClasses] = useState("card-hidden");

  // Fade-in effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setCardClasses("");
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/forgot-password`, {
        email
      });

      if (response.data.success) {
        setSuccessMsg(response.data.message || "A password reset link has been sent to your email.");
      } else {
        setErrorMsg(response.data.message || "Failed to request password reset.");
      }
    } catch (err) {
      console.error("Forgot password error:", err);
      setErrorMsg(err.response?.data?.message || "An error occurred while requesting password reset.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="section-image h-100"
      style={{
        backgroundImage: `url(${OrcaXBgLogo})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "contain"
      }}
    >
      <div style={{ backgroundColor: "transparent" }} className="content d-flex align-items-center p-0 my-auto h-100">
        <Container>
          <Col className="mx-auto" lg="6" md="8">
            <Form className="form border-0" onSubmit={handleSubmit}>
              <Card className={"card-login rounded " + cardClasses} style={{ border: "none", boxShadow: "none", background: "transparent" }}>
                {/* Header */}
                <Card.Header style={{ background: "transparent" }} className="text-center pt-4 pb-2">
                  <h3 style={{ fontWeight: "700", fontSize: "2.3rem" }} className="text-center mb-1">Reset Password</h3>
                  <small className="text-muted fs-6 font-weight-bold">
                    Enter your email address to receive a recovery link
                  </small>
                </Card.Header>

                {/* Body */}
                <Card.Body>
                  {errorMsg && <Alert variant="danger" className="text-center">{errorMsg}</Alert>}
                  {successMsg && <Alert variant="success" className="text-center">{successMsg}</Alert>}

                  {/* Email Field */}
                  <Form.Group className="mb-4">
                    <Form.Label style={{ fontWeight: "700", fontSize: ".9rem" }} className="text-dark text-capitalize">
                      Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      placeholder="e.g. john@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="fs-6 py-2"
                      style={{ borderRadius: "8px", border: "2px solid #dee2e6" }}
                    />
                  </Form.Group>
                </Card.Body>

                {/* Footer */}
                <Card.Footer className="text-center">
                  <Button
                    type="submit"
                    className="w-100 btn-wd fw-bolder py-2 px-4 fs-6 mb-3"
                    disabled={isSubmitting}
                    style={{ borderRadius: "8px", backgroundColor: "#014c95", border: "none" }}
                  >
                    {isSubmitting ? "Sending Link..." : "Send Reset Link"}
                  </Button>

                  <p className="mt-4 mb-0">
                    <small style={{ fontWeight: "700", fontSize: ".9rem" }}>
                      Remembered your password?{" "}
                      <Link to="/auth/login" className="fw-bold" style={{ color: "#0090ff" }}>
                        Sign In
                      </Link>
                    </small>
                  </p>
                </Card.Footer>
              </Card>
            </Form>
          </Col>
        </Container>
      </div>
    </div>
  );
}

export default ForgotPassword;
